import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const role = () => sessionStorage.getItem("adminRole") || "";
const adminName = () => sessionStorage.getItem("adminName") || "Admin";

const Icon = ({ children }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 0, flexShrink: 0 }}>
    {children}
  </svg>
);

// Modules still to be built (Phases 2+) route to /boutique/coming-soon with
// their own title/description so the nav structure is visible end-to-end
// even before each page exists.
const NAV_ITEMS = [
  {
    to: "/boutique/dashboard",
    label: "Dashboard",
    icon: (
      <Icon><rect x="3" y="3" width="7" height="9" rx="1.5" fill="#ede9fe" stroke="#7c3aed" strokeWidth="1.6"/><rect x="14" y="3" width="7" height="5" rx="1.5" fill="#ede9fe" stroke="#7c3aed" strokeWidth="1.6"/><rect x="14" y="12" width="7" height="9" rx="1.5" fill="#ede9fe" stroke="#7c3aed" strokeWidth="1.6"/><rect x="3" y="16" width="7" height="5" rx="1.5" fill="#ede9fe" stroke="#7c3aed" strokeWidth="1.6"/></Icon>
    ),
  },
  {
    to: "/customers",
    label: "Customer Master",
    icon: (
      <Icon><circle cx="9" cy="7" r="4" fill="#e9d5ff" stroke="#7c3aed" strokeWidth="1.8"/><path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" stroke="#7c3aed" strokeWidth="1.8" strokeLinecap="round"/></Icon>
    ),
  },
  {
    to: "/boutique/fabric-database",
    label: "Fabric Database",
    title: "Fabric Database",
    description: "Fabric ID, type, GSM, width, colour, print category, supplier, stock, images and cost — all in one catalog.",
    icon: (
      <Icon><rect x="3" y="4" width="18" height="16" rx="2" fill="#fce7f3" stroke="#db2777" strokeWidth="1.6"/><path d="M3 9h18M8 4v16" stroke="#db2777" strokeWidth="1.6"/></Icon>
    ),
  },
  {
    to: "/boutique/custom-printing",
    label: "Custom Printing",
    title: "Custom Fabric Printing Module",
    description: "Print design IDs, floral & surface pattern collections, reference images, colour/scale variations, sample approvals, MOQ and production status.",
    icon: (
      <Icon><rect x="4" y="3" width="16" height="14" rx="2" fill="#fef3c7" stroke="#d97706" strokeWidth="1.6"/><circle cx="9" cy="9" r="2" stroke="#d97706" strokeWidth="1.6"/><path d="M4 15l4-4 3 3 5-5 4 4" stroke="#d97706" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></Icon>
    ),
  },
  {
    to: "/boutique/order-management",
    label: "Order Management",
    icon: (
      <Icon><path d="M6 2h9l4 4v16H6z" fill="#dbeafe" stroke="#2563eb" strokeWidth="1.6"/><path d="M9 11h6M9 15h6" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round"/></Icon>
    ),
  },
  {
    to: "/boutique/crm",
    label: "CRM",
    title: "Customer Relationship Management",
    description: "Birthday & anniversary wishes, festival greetings, new-collection alerts, WhatsApp campaigns, repeat-purchase & referral tracking, VIP program.",
    icon: (
      <Icon><path d="M12 21s-7-4.35-9.5-8.5C.5 8.5 3 5 6.5 5c2 0 3.5 1.2 5.5 3 2-1.8 3.5-3 5.5-3 3.5 0 6 3.5 4 7.5C19 16.65 12 21 12 21z" fill="#fce7f3" stroke="#db2777" strokeWidth="1.6" strokeLinejoin="round"/></Icon>
    ),
  },
  {
    to: "/boutique/analytics",
    label: "Analytics",
    title: "Analytics Dashboard",
    description: "Top & repeat customers, best-selling designs and fabrics, revenue, tailoring and fabric profit reports, and customer lifetime value.",
    icon: (
      <Icon><path d="M4 20V10M11 20V4M18 20v-7" stroke="#4c51bf" strokeWidth="2" strokeLinecap="round"/></Icon>
    ),
  },
];

const BoutiqueSidebar = () => {
  const navCls = ({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`;

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/admin/login";
  };

  return (
    <div className="sidebar">
      <div className="sidebar-user-top">
        <div className="sidebar-user-avatar">{adminName().charAt(0).toUpperCase()}</div>
        <div className="sidebar-user-info">
          <span className="sidebar-user-name">{adminName()}</span>
          <span className="sidebar-user-role">{role() || "—"} · Boutique</span>
        </div>
      </div>

      <div className="sidebar-scroll">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            state={item.title ? { title: item.title, description: item.description } : undefined}
            className={navCls}
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>

      <div className="sidebar-footer">
        <button className="sidebar-logout-btn" onClick={handleLogout}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 17l5-5-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Logout
        </button>
      </div>
    </div>
  );
};

export default BoutiqueSidebar;
